import React, { FC, useCallback } from 'react';
import { HidingTooltip, TooltipPosition } from './HidingTooltip';

interface IHidingTextTooltipProps {
  enabled?: boolean;
  children: React.ReactNode;
  tooltipContent: React.ReactNode;
  width?: string;
  position?: TooltipPosition;
  showShadow?: boolean;
  tooltipWrapperClassname?: string;
  tooltipContentClassname?: string;
  tooltipClassname?: string;
  elementClassname?: string;
  usePortal?: boolean;
  keepTooltipOnHover?: boolean;
}

export const HidingTextTooltip: FC<IHidingTextTooltipProps> = React.memo(
  ({
    enabled = true,
    children,
    tooltipContent,
    tooltipWrapperClassname = '',
    tooltipContentClassname = '',
    tooltipClassname = '',
    elementClassname = '',
    width = 'max-content',
    showShadow = true,
    position = 'bottom',
    usePortal = false,
    keepTooltipOnHover = false,
  }) => {
    const renderTooltipContent = useCallback(() => {
      return (
        <div className={`${tooltipContentClassname ?? ''} text-13px leading-17px font-pt-sans font-normal text-black rounded text-left`} style={{ width }}>
          {tooltipContent}
        </div>
      );
    }, [tooltipContentClassname, width, tooltipContent]);

    return (
      <HidingTooltip 
        renderTooltipContent={renderTooltipContent} 
        position={position}
        showShadow={showShadow} 
        tooltipWrapperClassname={tooltipWrapperClassname}
        tooltipClassname={tooltipClassname}
        elementClassname={elementClassname}
        usePortal={usePortal}
        keepTooltipOnHover={keepTooltipOnHover}
        enabled={enabled}
      >
        {children}
      </HidingTooltip>
    );
  }
);
